import { getAPI } from "../Networking";
import { OpsAnalyticsData } from "../../models/Dashboard/OpsDashboard/OpsAnalytics";
import {
  AnalyticsGraphResponse,
  LabelValue,
} from "../../models/Dashboard/Analytics";
import dayjs from "dayjs";
import { CustomerExperienceAPIFilters } from "../../models/Dashboard/CustomerExperienceDashboard/CustomerExperienceFilters";

export default class CustomerExperienceDashboardAPI {
  getTatsData = async (
    url: string,
    filters: CustomerExperienceAPIFilters,
  ): Promise<LabelValue[] | AnalyticsGraphResponse[] | OpsAnalyticsData> => {
    try {
      const start_date = dayjs(filters.start_date, "YYYY-MM-DD")
        .utc()
        .format("YYYY-MM-DD HH:mm:ss");

      const end_date = dayjs(filters.end_date, "YYYY-MM-DD")
        .add(1, "day")
        .utc()
        .format("YYYY-MM-DD HH:mm:ss");

      const queryParams = new URLSearchParams();

      if (start_date) queryParams.append("start_date", start_date);

      if (end_date) queryParams.append("end_date", end_date);

      if (filters.order_type && filters.order_type.length > 0) {
        queryParams.append(
          "order_type",
          filters.order_type.map((item) => item.id).join(","),
        );
      }

      if (filters.pm_admin_id && filters.pm_admin_id.length > 0) {
        queryParams.append(
          "pm_admin_id",
          filters.pm_admin_id.map((item) => item.id).join(","),
        );
      }

      const response = await getAPI(
        `/v5/customer-exp-analytics/${url}?${queryParams.toString()}`,
      );
      return response.result;
    } catch (error) {
      throw error;
    }
  };
}
